import { render, staticRenderFns } from "./ChatbotDetails.vue?vue&type=template&id=133da1e4&scoped=true&"
import script from "./ChatbotDetails.vue?vue&type=script&lang=js&"
export * from "./ChatbotDetails.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotDetails.vue?vue&type=style&index=0&id=133da1e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133da1e4",
  null
  
)

export default component.exports